import React, { useMemo } from 'react';
import toast from 'react-hot-toast';
import { FormDialog, RhfTextField } from '@core/components';
import type {
  CreateLegacyCollarData,
  LegacyCollar,
} from '../../api/legacyCollar';
import { createLegacyCollar, updateLegacyCollar } from '../../api/legacyCollar';

interface LegacyCollarDialogProps {
  open: boolean;
  onClose: () => void;
  collar?: LegacyCollar | null;
  onSuccess?: () => void;
}

type LegacyCollarFormValues = {
  name: string;
};

const LegacyCollarDialog: React.FC<LegacyCollarDialogProps> = ({
  open,
  onClose,
  collar,
  onSuccess,
}) => {
  const defaultValues = useMemo<LegacyCollarFormValues>(
    () => ({
      name: collar?.name ?? '',
    }),
    [collar]
  );

  const onSubmit = async (data: LegacyCollarFormValues) => {
    const payload: CreateLegacyCollarData = {
      name: data.name.trim(),
    };
    if (collar) {
      await updateLegacyCollar(collar.id, payload);
      toast.success('Collar updated successfully');
    } else {
      await createLegacyCollar(payload);
      toast.success('Collar created successfully');
    }
    onSuccess?.();
  };

  return (
    <FormDialog<LegacyCollarFormValues>
      open={open}
      onClose={onClose}
      title={collar ? 'Edit Alb Collar' : 'Add Alb Collar'}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      submitText={collar ? 'Update' : 'Add'}
      cancelText="Cancel"
    >
      <RhfTextField<LegacyCollarFormValues> name="name" label="Name" required />
    </FormDialog>
  );
};

export default LegacyCollarDialog;
